import React from 'react';
import { Container, Header, Image } from 'semantic-ui-react';

import aiImage from '../../../images/grafix-banner/aiPage.svg';

const AIntelligence = () => (
    <Container className="demoImage">
        <Header as='h2' icon textAlign='center'>
            <Header.Content>
                Analytics
            </Header.Content>
        </Header>
        <Image src={aiImage} size='large' centered={true} />

    </Container>
);

export default AIntelligence;